/**
 * Created by Ella Ma on 04/15/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

import { FocusSettinActionType, FocusSettingConfig, FocusSettingEventType, UsePage } from '../../focus-setting/focus-setting.model';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TileSettingsConfig } from './tile-settings.model';
import { TamDashboardTileType } from '../../../tam-dashboard/tam-dashboard.model';
import { ScreenFocusType } from '../../../../models/saved-screen';

@Component({
    selector: 'tam-tile-settings',
    templateUrl: './tile-settings.component.html',
    styleUrls: ['./tile-settings.component.scss']
})
export class TileSettingsComponent implements OnInit, OnDestroy {

    @Input() config: TileSettingsConfig;
    contentForm = new UntypedFormGroup({
        name: new UntypedFormControl(''),
        description: new UntypedFormControl(''),
    });
    get name() {
        return this.contentForm.get('name');
    }
    get description() {
        return this.contentForm.get('description');
    }

    focusSettingConfig: FocusSettingConfig = new FocusSettingConfig();
    errorMsg: string;
    private _subscriptions$: Subscription[] = [];

    constructor() { }

    ngOnInit() {
        this.focusSettingConfig.config.page = UsePage.tile;
        this.name.setValue(this.config.name);
        this.description.setValue(this.config.description);
        this.focusSettingConfig.config.focus = _.cloneDeep(this.config.focus);
        this.focusSettingConfig.config.disabledEnabledFocusRelationship = this.config.screenFocusType !== ScreenFocusType.ENABLE_FOCUS_CONTROL;
        this.focusSettingConfig.config.disabledAllFocus = this.config.type === TamDashboardTileType.MAP;
        this._initSubscriptions();
    }

    ngOnDestroy(): void {
        this._subscriptions$.forEach(item => item.unsubscribe());
    }

    validSetting() {
        return !this._doValidation() && !this._validFocus();
    }

    changName() {
        this.config.name = this.name.value;
    }

    changDescription() {
        this.config.description = this.description.value;
    }

    onSave() {
        const data: TileSettingsConfig = {
            name: this.name.value,
            description: this.description.value,
            focus: {
                type: this.focusSettingConfig.config.focus.type
            }
        };
        const focus = this.focusSettingConfig.config.focus;
        if (focus.type === ScreenFocusType.ENABLE_FOCUS_CONTROL) {
            if (focus.enableFocusRelationType) {
                data.focus.relationshipTypes = focus.relationshipTypes || [];
            } else {
                delete data.focus.relationshipTypes;
            }
        } else if (focus.type === ScreenFocusType.SPECIFIC_ENTITY) {
            data.focus.entityId = focus.entityId;
            if (focus.entityRelationshipType) {
                data.focus.relationshipTypes = focus.relationshipTypes || [];
                if (focus.includeSpecificEntityItself) {
                    data.focus.includeSpecificEntityItself = true;
                } else {
                    data.focus.includeSpecificEntityItself = false;
                }
            } else {
                data.focus.relationshipTypes = [];
            }
        } else if (focus.type === ScreenFocusType.CURRENT_USER) {
            if (focus.enableCurrentUserRelationship) {
                data.focus.relationshipTypes = focus.relationshipTypes || [];
            } else {
                data.focus.relationshipTypes = [];
            }
        }
        return data;
    }

    refreshName() {
        this.name.setValue(this.config.name);
    }

    refreshFocus() {
        this.focusSettingConfig.config.disabledEnabledFocusRelationship = this.config.screenFocusType !== ScreenFocusType.ENABLE_FOCUS_CONTROL;
        this.focusSettingConfig.config.focus = this.config.focus;
        this.focusSettingConfig.actions$.next({
            type: FocusSettinActionType.refreshFocus,
            payload: this.config.focus
        });
    }

    private _initSubscriptions() {
        this._subscriptions$.push(
            this.focusSettingConfig.events$.pipe(
                filter(item => item.type === FocusSettingEventType.valueChange)
            ).subscribe(() => {
                this.errorMsg = '';
            })
        );
    }

    private _validFocus(): boolean {
        let inValid;
        const focus = this.focusSettingConfig.config.focus;
        if (focus.type === ScreenFocusType.ENABLE_FOCUS_CONTROL) {
            inValid = focus.enableFocusRelationType && (!focus.relationshipTypes || focus.relationshipTypes.length === 0);
        } else if (focus.type === ScreenFocusType.SPECIFIC_ENTITY) {
            inValid = !focus.entityId || (focus.entityRelationshipType && (!focus.relationshipTypes || focus.relationshipTypes.length === 0));
        } else if (focus.type === ScreenFocusType.CURRENT_USER) {
            inValid = focus.enableCurrentUserRelationship && (!focus.relationshipTypes || focus.relationshipTypes.length === 0);
        } else {
            inValid = false;
        }
        if (inValid) {
            this.errorMsg = 'Please enter information for require field.';
        }
        return inValid;
    }

    private _doValidation(): boolean {
        let inValid = false;
        this.name.setErrors(null);
        this.description.setErrors(null);

        if (!this.name.value) {
            this.name.setErrors({
                required: true
            });
            inValid = true;
        } else if (this.name.value.length > 64) {
            this.name.setErrors({
                maxlength: true
            });
            inValid = true;
        }

        if (this.description.value && this.description.value.length > 128) {
            this.description.setErrors({
                maxlength: true
            });
            inValid = true;
        }
        return inValid;
    }
}
